/**
 * This function is responsible for updating the filters active classes
 *
 * @param {HTMLElement} element
 * @param {string}      activeClass
 */
export default function updateFilters(element, activeClass) {
	const activeFilter = document.querySelector('li.' + activeClass);
	if (
		activeFilter instanceof window.HTMLElement &&
		element instanceof window.HTMLElement
	) {
		activeFilter.classList.remove(activeClass);
		element.classList.add(activeClass);
	}
}
